import { createContext } from 'react';

import { Context } from '../../../types';
import { CreditCompanyType } from '../types';
import api from '../api';
import { getContextDefaultValues } from '../../providersDataManager';

export default createContext<Context<CreditCompanyType>>(getContextDefaultValues(api));
